export default [
  {
    path: '/menzhenjiaofei',
    name: 'Menzhenjiaofei',
    meta: { title: '门诊缴费', keepAlive: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/menzhenjiaofei/menzhenjiaofei')
  },
  {
    path: '/menzhenjiaofeijilu',
    name: 'menzhenjiaofeijilu',
    meta: { title: '门诊缴费记录' },
    component: () => import(/* webpackChunkName: "about" */ '../views/menzhenjiaofei/menzhenjiaofeijilu')
  },
  {
    path: '/jiaofeimingxi',
    name: 'jiaofeimingxi',
    meta: { title: '缴费明细' },
    component: () => import(/* webpackChunkName: "about" */ '../views/menzhenjiaofei/jiaofeimingxi')
  }
]
